define(function(require,exports,module) {
    var goTop = function(options) {
        var defaults = {
            midWidth: 1210
        };
        var settings = $.extend(defaults, options || {});

        var init = function() {
            //解决IE7下影响footer的margin-top失效问题
            $("#go-top").after("<div></div>");
            setLocation();
            setVisible();
            handleResize();
            highlight();
            handleScroll();
        };
        var handleResize = function() {
            $(window).resize(function() {
                adaptWidth();
                setLocation();
            });
        };
        var handleScroll = function() {
            $(window).scroll(function() {
                setVisible();
            });
            $(".go-top a").bind("click", function() {
                $(".go-top").addClass("clk");
                if($(this).hasClass("j-go-top")) {
                    $("html,body").animate({scrollTop: 0});
                    $(this).siblings().removeClass("hover");
                } else {
                    var dataIdx = $(this).attr("data-index");
                    var scrollTop = $("div[data-idx='"+dataIdx+"']").offset().top;
                    $("html,body").animate({scrollTop: scrollTop});
                    $(this).addClass("hover").siblings().removeClass("hover");
                }
                setTimeout(function() {
                    $(".go-top").removeClass("clk");
                }, 500);
            });

        };
        var setLocation = function() {
            var winWidth = $(window).width();
            var midWidth = settings.midWidth;
            $("#go-top").css("right", (winWidth - midWidth)/2 - 62 - 20);
        };
        var setVisible = function() {
            if(!adaptWidth()) {
                return false;
            }

            if($(this).scrollTop() > 215 ) {
                $("#go-top").css("display", "block");
            } else {
                $("#go-top").css("display", "none");
            }
        };
        var highlight = function() {
            $(window).scroll(function() {
                if($(".go-top").hasClass("clk")) {
                    return false;
                }
                $("[data-idx]").each(function() {
                    var scrollTop = $(document).scrollTop();
                    var offsetTop = $(this).offset().top;

                    var offset = offsetTop - scrollTop;

                    if(offset < 200 && offset > 0) {
                        var dataIdx = $(this).attr("data-idx");
                        $("a[data-index='"+dataIdx+"']").addClass("hover").siblings().removeClass("hover");
                        return false;
                    }
                });
            });
        };
        var adaptWidth = function() {
            if($(window).width() < 1350) {
                $(".go-top").css("display", "none");
                return false;
            } else {
                $(".go-top").css("display", "block");
                return true;
            }
        };
        init();
    };
    exports.goTop = goTop;
});


// WEBPACK FOOTER //
// ./src/js/unit/gotop/gotopV2.js